/* ============================================================
   sm-magnafslattur.js

   Lætur magnafsláttarmiðana (snippets/sm-magnafslattur.liquid) segja
   satt um leið og eitthvað breytist. Enginn texti býr hér: snippetið
   teiknar allar setningarnar og þessi skrá velur hverja á að sýna
   (data-sm-magn-ef) og setur inn tölur.

   TVÖ TILVIK:

   1. VÖRUSÍÐA (data-sm-magn="vara"). Fjöldinn sem gildir er það sem er
      þegar í körfunni PLÚS það sem er valið á síðunni, því afslátturinn
      telur allar vörur í körfunni. Fjöldastikan er lesin af stakinu sem
      data-sm-magn-fjoldi vísar á og MutationObserver fylgist með því.
      Þannig þarf engin af síðuskriftunum (sm-oryggisskilti.js, sm-wc.js,
      sm-hurda-config.js) að vita af þessari skrá.

   2. STAÐFESTINGARBORÐINN (data-sm-magn="bordi"). Fylltur úr /cart.js
      eftir að eitthvað fór í körfuna. Sex ólíkar skriftur bæta í körfu
      (sm-main.js, sm-hurda-config.js, sm-husnumer.js, sm-krossaskilti.js,
      sm-oryggisskilti.js, sm-wc.js) og þær opna borðann hver á sinn hátt.
      Þess vegna er hlustað á beiðnina sjálfa, eins og sm-hurda-flow.js
      gerir: fetch (og XMLHttpRequest, sem SMFram.senda notar) er vafið og hvert
      vel heppnað /cart/add, /cart/change, /cart/update eða /cart/clear sækir
      körfuna upp á nýtt.

   Körfusíðan (stadur 'karfa') þarf ekkert héðan; hún endurhleðst við
   hverja breytingu og Liquid reiknar allt.

   ÞREPIN verða að passa við sjálfvirku afslættina í Admin:
   10% frá 2 vörum og 15% frá 5 (sjá snippetið). Ekkert 20% þrep: frá
   10 vörum er tilboðslínan (data-sm-magn-tilbod) áherslumerkt. Aðeins
   raunverulegar vörur teljast, vara með aukavali er ein vara: Owala
   brúsar (product_type 'Brúsar') og aukagjöld (product_type 'Aukagjald',
   t.d. logo á gæludýramerki) teljast ekki með og fá ekki afsláttinn.
   ============================================================ */
(function () {
  'use strict';
  if (!window.fetch || !document.querySelectorAll) return;

  var LAGMARK_10 = 2, LAGMARK_15 = 5, STOR = 10;
  var BRUSAR = 'Brúsar', UTAN = { 'Brúsar': 1, 'Aukagjald': 1 };
  var frumFetch = window.fetch;
  var iKorfu = null, brusarIKorfu = null;

  /* Fjöldinn sem telur: allar vörur nema Owala brúsar og aukagjöld
     (logoið á gæludýramerkinu er aukaval á merkinu, sama lína, ein vara). */
  function teljanleg(cart) {
    var s = 0, a = (cart && cart.items) || [];
    for (var i = 0; i < a.length; i++) if (!UTAN[a[i].product_type]) s += a[i].quantity || 0;
    return s;
  }
  function brusar(cart) {
    var s = 0, a = (cart && cart.items) || [];
    for (var i = 0; i < a.length; i++) if (a[i].product_type === BRUSAR) s += a[i].quantity || 0;
    return s;
  }

  function pct(n) { return n >= LAGMARK_15 ? 15 : (n >= LAGMARK_10 ? 10 : 0); }
  /* Punktur sem þúsundaskil, handvirkt. toLocaleString('is-IS') skilar
     kommu í vöfrum sem bera ekki íslensku staðfærslugögnin. */
  function kr(aurar) {
    return String(Math.round((aurar || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
  }
  function allt(sel, rot) { return Array.prototype.slice.call((rot || document).querySelectorAll(sel)); }

  function syna(el, lykill) {
    allt('[data-sm-magn-ef]', el).forEach(function (s) {
      s.hidden = s.getAttribute('data-sm-magn-ef') !== lykill;
    });
  }

  /* "Ein vara í viðbót" má aðeins standa þar sem það er satt: þegar ein
     vara til viðbótar lyftir körfunni upp í næsta þrep (4 -> 15%) og
     afslátturinn sem Shopify reiknaði (nu) er lægri en það.
     data-sm-magn-vid segir hvaða þrep setningin lofar. */
  function naesta(el, n, nu) {
    var nyr = pct(n + 1) > pct(n) ? pct(n + 1) : 0;
    if (nu && nyr <= nu) nyr = 0;
    allt('[data-sm-magn-vid]', el).forEach(function (s) {
      s.hidden = parseInt(s.getAttribute('data-sm-magn-vid'), 10) !== nyr;
    });
  }

  /* ---------- 1. Vörusíða ---------- */
  function valinn(el) {
    var sel = el.getAttribute('data-sm-magn-fjoldi');
    var st = sel ? document.querySelector(sel) : null;
    var q = st ? parseInt(st.textContent, 10) : 1;
    return q > 0 ? q : 1;
  }

  function vara(el) {
    var ik = iKorfu !== null ? iKorfu : (parseInt(el.getAttribute('data-sm-magn-i-korfu'), 10) || 0);
    var q = valinn(el), p = pct(ik + q);
    allt('[data-sm-magn-t]', el).forEach(function (t) {
      t.classList.toggle('er-nad', p > 0 && parseInt(t.getAttribute('data-sm-magn-t'), 10) === p);
    });
    el.classList.toggle('er-nad', p > 0);
    allt('[data-sm-magn-q]', el).forEach(function (s) { s.textContent = q; });
    naesta(el, ik + q);
    syna(el, p === 0 ? '0' : p + (ik > 0 ? '-karfa' : '-stk'));
    allt('[data-sm-magn-tilbod]', el).forEach(function (s) { s.classList.toggle('er-stor', ik + q >= STOR); });
    if (brusarIKorfu !== null) allt('[data-sm-magn-brusi]', el).forEach(function (s) { s.hidden = !brusarIKorfu; });
  }

  function fylgjaFjolda(el) {
    var sel = el.getAttribute('data-sm-magn-fjoldi');
    var st = sel ? document.querySelector(sel) : null;
    if (st && window.MutationObserver) {
      new MutationObserver(function () { vara(el); })
        .observe(st, { childList: true, characterData: true, subtree: true });
    }
    vara(el);
  }

  /* ---------- 2. Staðfestingarborðinn ---------- */
  /* Afsláttur á pöntun (cart_level_discount_applications, eldri gerðin) eða
     á línum (line_level_discount_allocations, afsláttur á safnið
     Magnafsláttur gildir). Fundinn eftir titlinum; upphæðin er summan og
     prósentan (pct) sú hæsta, úr value (prósentuafsláttur) eða titlinum. */
  function umsPct(d) {
    if (d && d.value_type === 'percentage' && !isNaN(parseFloat(d.value))) return parseFloat(d.value);
    var m = /(\d+)\s*%/.exec((d && d.title) || '');
    return m ? parseInt(m[1], 10) : 0;
  }
  function magnUmsokn(cart) {
    var a = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < a.length; i++) {
      if (/^magnafsl/i.test(a[i].title || '')) return { title: a[i].title, total_allocated_amount: a[i].total_allocated_amount, pct: umsPct(a[i]) };
    }
    var titill = '', upph = 0, hp = 0, l = (cart && cart.items) || [];
    for (var j = 0; j < l.length; j++) {
      var d = l[j].line_level_discount_allocations || [];
      for (var k = 0; k < d.length; k++) {
        var da = d[k].discount_application || {}, t = da.title || '';
        if (/^magnafsl/i.test(t)) { titill = titill || t; upph += d[k].amount || 0; hp = Math.max(hp, umsPct(da)); }
      }
    }
    return titill ? { title: titill, total_allocated_amount: upph, pct: hp } : null;
  }

  /* Enska (/en): titill afsláttarins kemur úr [data-sm-magn-ord] í borðanum (JSON, aðeins utan aðaltungumáls); annars titillinn frá Shopify (íslenska) */
  function magnTitill(el, u) {
    var oe = el.querySelector('[data-sm-magn-ord]'), ord = null;
    if (oe) { try { ord = JSON.parse(oe.textContent); } catch (e) { ord = null; } }
    if (!ord) return u.title;
    if (u.pct > 0 && ord.titill_pct) return String(ord.titill_pct).split('XPCTX').join(Math.round(u.pct));
    return ord.titill || u.title;
  }

  function bordi(el, cart) {
    var c = teljanleg(cart), b = brusar(cart);
    var tilbod = allt('[data-sm-magn-tilbod]', el);
    /* Síða Owala brúsa eða aukagjalds: hvorki þrep, afsláttur né tilboð, aðeins að brúsarnir séu ekki með */
    if (el.hasAttribute('data-sm-magn-utan')) {
      allt('[data-sm-magn-ef], [data-sm-magn-vid]', el).forEach(function (s) { s.hidden = true; });
      allt('[data-sm-magn-brusi]', el).forEach(function (s) { s.hidden = !b; });
      tilbod.forEach(function (s) { s.hidden = true; });
      el.classList.remove('er-nad');
      el.hidden = !b;
      return;
    }
    if (!c) { el.hidden = true; return; }
    allt('[data-sm-magn-brusi]', el).forEach(function (s) { s.hidden = !b; });
    tilbod.forEach(function (s) { s.hidden = c < STOR; });
    var u = magnUmsokn(cart);
    if (u) {
      var tt = magnTitill(el, u);
      allt('[data-sm-magn-titill]', el).forEach(function (s) { s.textContent = tt; });
      allt('[data-sm-magn-sparar]', el).forEach(function (s) { s.textContent = kr(u.total_allocated_amount); });
      /* 16.10: upphæðin sést aðeins þegar hún er til (annars stóð "þú sparar ." með tómri tölu) */
      allt('[data-sm-magn-spar-hluti]', el).forEach(function (s) { s.hidden = !(u.total_allocated_amount > 0); });
      allt('[data-sm-magn-spar-punktur]', el).forEach(function (s) { s.hidden = u.total_allocated_amount > 0; });
    }
    naesta(el, c, u ? u.pct : 0);
    el.classList.toggle('er-nad', !!u);
    /* Sá afsláttur sem Shopify reiknaði gildir: gömlu afslættirnir á pöntun telja líka logo og brúsa */
    syna(el, u ? 'nad' : (c === 1 ? '1' : 'almennt'));
    el.hidden = false;
  }

  /* ---------- Tappagjald húsfélagsskilta (08.10) ----------
     "Tappar á skilti" (handle tappar-a-skilti, 600 kr, ein lína á lit tappa) fylgir skiltinu: 2 tappar á "Göt (2)", 4 á "Göt (4)" fyrir
     hvert skilti með sama lit tappa (eiginleikinn Tappar). Þessi skrifta hleðst á ÖLLUM síðum og sér hverja körfubreytingu (líka þá sem
     kemur úr körfuglugganum), svo gjaldið verður aldrei eftir án skiltis: eftir hverja /cart beiðni fær uppfaera() nýju körfuna og
     tapparSamstilla() lagar eða fjarlægir gjaldlínuna. Aðeins ein leiðrétting í einu (lás), eigin leiðrétting fer um frumFetch (vafin
     fetch sér hana ekki) og endurskoðar svo körfuna einu sinni; í mesta lagi 4 leiðréttingar á 10 s, svo aldrei myndast lykkja. */
  var TAPPAR_HANDLE = 'tappar-a-skilti', tapparLas = false, tapparSaga = [], tapparTimer = null, opid = 0;
  /* Skiltið fer í körfu á undan gjaldinu (kitið sendir tappana eftir á, einn í einu): leiðrétt er því aðeins þegar engin körfubeiðni er í
     gangi og karfan hefur verið kyrr í 400 ms, og þá úr NÝRRI körfu, svo hálfkláruð bæting leiðréttist aldrei í ranga átt. */
  function tapparPlanlegg() {
    if (tapparTimer) clearTimeout(tapparTimer);
    tapparTimer = setTimeout(function () {
      tapparTimer = null;
      if (opid > 0) { tapparPlanlegg(); return; }
      frumFetch.call(window, ((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (opid === 0) tapparSamstilla(c); })['catch'](function () {});
    }, 400);
  }
  function tapparSamstilla(cart) {
    if (tapparLas || !cart || !cart.items) return;
    var gjold = [], i, j, it, sk, upp = {}, breyta = false, n = 0;
    for (i = 0; i < cart.items.length; i++) if (cart.items[i].handle === TAPPAR_HANDLE) gjold.push(cart.items[i]);
    if (!gjold.length) return;
    for (i = 0; i < gjold.length; i++) {
      var lit = gjold[i].properties && gjold[i].properties.Tappar, vaent = 0;
      for (j = 0; j < cart.items.length; j++) {
        sk = cart.items[j];
        if (sk.handle === TAPPAR_HANDLE || !sk.properties || !lit || sk.properties.Tappar !== lit) continue;
        vaent += (String(sk.properties.Festing || '').indexOf('(4)') >= 0 ? 4 : 2) * (sk.quantity || 0);
      }
      if (vaent !== gjold[i].quantity) { upp[gjold[i].key] = vaent; breyta = true; }
    }
    if (!breyta) return;
    var nu = Date.now();
    tapparSaga = tapparSaga.filter(function (t) { return nu - t < 10000; });
    if (tapparSaga.length >= 4) return;
    tapparSaga.push(nu);
    tapparLas = true;
    frumFetch.call(window, ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ updates: upp })
    }).then(function (r) {
      tapparLas = false; saekja();
      /* L1 22.10: karfan (sm-cart.liquid) endurteiknar sig við þetta, annars sýndi hún gamla gjaldlínu og ranga samtölu eftir + / - */
      if (r && r.ok) { try { document.dispatchEvent(new CustomEvent('sm:tappar-lagad')); } catch (e) {} }
    }, function () { tapparLas = false; });
  }

  /* ---------- Karfan ---------- */
  function uppfaera(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    iKorfu = teljanleg(cart);
    brusarIKorfu = brusar(cart);
    tapparPlanlegg();
    /* fjoldi = allt í körfunni (eins og aðrar skriftur senda), magn = það sem telur til magnafsláttar */
    try { document.dispatchEvent(new CustomEvent('sm:karfa', { detail: { fjoldi: cart.item_count, magn: iKorfu } })); } catch (e) {}
    allt('[data-sm-magn="vara"]').forEach(vara);
    allt('[data-sm-magn="bordi"]').forEach(function (el) { bordi(el, cart); });
  }

  function saekja() {
    var slod = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    return frumFetch.call(window, slod, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(uppfaera)['catch'](function () { /* þögn: miðinn má aldrei fella körfuna */ });
  }

  var BREYTING = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input) {
    var slod = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
    var svar = frumFetch.apply(window, arguments);
    if (BREYTING.test(slod)) {
      opid += 1; svar.then(function () { opid = Math.max(0, opid - 1); }, function () { opid = Math.max(0, opid - 1); });
      /* Borðinn getur opnast áður en nýja karfan er komin. Gamla talan
         má ekki standa á honum á meðan, svo hann er falinn þar til
         saekja() hefur svarað. */
      allt('[data-sm-magn="bordi"]').forEach(function (el) { el.hidden = true; });
      svar.then(function (r) { if (r && r.ok) saekja(); })['catch'](function () {});
    }
    return svar;
  };
  /* Lína með framleiðsluskrá fer í körfu um SMFram.senda (sm-framleidsla.js) með XMLHttpRequest, ekki
     fetch, því hún þarf að vita hvenær skráin er komin upp. Sama hlustun þar. */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.send) {
    var xOpna = XMLHttpRequest.prototype.open, xSenda = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (adferd, slod) {
      this.__smMagnSlod = typeof slod === 'string' ? slod : String(slod || '');
      return xOpna.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (BREYTING.test(x.__smMagnSlod || '')) {
        allt('[data-sm-magn="bordi"]').forEach(function (el) { el.hidden = true; });
        opid += 1;
        x.addEventListener('loadend', function () { opid = Math.max(0, opid - 1); if (x.status >= 200 && x.status < 300) saekja(); });
      }
      return xSenda.apply(this, arguments);
    };
  }

  function byrja() {
    var vorur = allt('[data-sm-magn="vara"]');
    vorur.forEach(fylgjaFjolda);
    /* tappagjald: ein athugun við hleðslu á hverri síðu þar sem karfa er til (cart-cookie), ef gjald varð eftir */
    try { if (document.cookie.indexOf('cart=') >= 0 && !vorur.length) saekja(); } catch (e) {}
    /* Liquid gaf körfufjöldann við teikningu. Hann er sóttur aftur svo
       miðinn standist líka þótt síðan komi úr skyndiminni. */
    if (vorur.length) saekja();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', byrja);
  else byrja();

  /* Til baka-hnappurinn getur skilað síðunni úr bfcache eftir að eitthvað
     var sett í körfuna annars staðar. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && allt('[data-sm-magn="vara"]').length) saekja();
  });
})();
